<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title" v-if="this.product.variante_label">
                {{this.product.variante_label}}
            </h5>
            <h5 class="modal-title" v-else>
                {{$t('ordine.variante_titolo')}}
            </h5>
        </div>
        <div slot="body">
            {{$t('ordine.variante_sel')}}:
            <br/>
            <ul>
                <li v-if="this.standard_variant_enabled">
                    <mcw-radio v-model="variant_id" name="variante" :id="'variant_standard'"
                               :label="this.product.variante_nome ? this.product.variante_nome : $t('nessuna')"
                               :value="'0'"/>
                </li>
                <li v-for="(variant, i) in this.variants">
                    <mcw-radio v-model="variant_id" name="variante" :id="'variant_'+i"
                               :label="variant.nome+' ('+variant.prezzo.toFixedGood(2)+' '+locale_currency+')'"
                               :value="variant.id.toString()"/>
                </li>
            </ul>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="$emit('close', parseInt(variant_id))">
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalVariants",
        components: {Modal},
        props: ['product', 'measure', 'variantId'],
        data() {
            return {
                variant_id: this.variantId ? this.variantId.toString() : '0'
            }
        },
        computed: {
            variants: function () {
                //Genero le varianti disponibili
                let variants = [];

                this.product.varianti.forEach((variant) => {
                    const firstPrice = this.product.prezzi.find((price) => {
                        return ((price.id_misura_tipologia_prodotto === this.measure.id) && (variant.id === price.id_variante_tipologia_prodotto));
                    });

                    if (firstPrice) {
                        variants.push({
                            id: variant.id,
                            nome: variant.nome,
                            prezzo: (firstPrice.prezzo - this.measure.prezzo)
                        });
                    }
                });

                return variants;
            },
            standard_variant_enabled: function () {
                //Controllo se la variante standard è abilitata
                return !!this.product.prezzi.find((price) => {
                    return ((price.id_misura_tipologia_prodotto === this.measure.id) && (null === price.id_variante_tipologia_prodotto));
                });
            },
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        }
    }
</script>
